import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

// Check more icons at here https://react-icons.github.io/react-icons/icons?name=fa
import { FaCheckCircle, FaPlus } from 'react-icons/fa'

import CustomRoomPicker from './CustomAdminComponents/CustomRoomPicker'
import RoomDisplay from './CustomAdminComponents/RoomDisplay'

import {ThemeProvider} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import {appTheme, parseEvents, validateField} from '../../utils'

import {
    CREATE_STATE,
    FOUND_STATE,
    DELETED_STATE,
    CREATE_SUCCESS_STATE,
    CREATE_FAILED_STATE,
    UPDATE_SUCCESS_STATE,
    UPDATE_FAILED_STATE,
    NOT_CHOOSEN_STATE,
    NUMBER_FIELD,
    STRING_FIELD
} from "../../constants"

import {
    CHOOSE_AN_OPTION_TEXT
} from '../../strings'

import "react-datepicker/dist/react-datepicker.css";

class RoomsAdmin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            rooms: {},
            selectedRoomId: null,
            roomState: NOT_CHOOSEN_STATE,
            errorMessages: {
                invalidName: false,
                invalidCapacity: false
            }
        }
        this.handleRoomChange = this.handleRoomChange.bind(this)
        this.handleRoomCreate = this.handleRoomCreate.bind(this)
        this.handleRoomNameChange = this.handleRoomNameChange.bind(this)
        this.handleRoomCapacityChange = this.handleRoomCapacityChange.bind(this)
        this.handleClickUpdate = this.handleClickUpdate.bind(this)
        this.getRoomErrors = this.getRoomErrors.bind(this)
        this.handleClickDelete = this.handleClickDelete.bind(this)
        this.handleRoomAvailableChange = this.handleRoomAvailableChange.bind(this)
    }

    handleRoomChange(event){
        const value = event.target.value
        if (value === CHOOSE_AN_OPTION_TEXT){
            this.setState({
                roomState: NOT_CHOOSEN_STATE,
                selectedRoomId: null,
                errorMessages: {
                    invalidName: false,
                    invalidCapacity: false
                }
            })
            return
        }
        this.setState({
            roomState: FOUND_STATE,
            selectedRoomId: value,
            errorMessages: {
                invalidName: false,
                invalidCapacity: false
            }
        })
    }

    handleRoomCreate(){
        const {rooms} = this.state
        const newRoom = {
            name: '',
            capacity: 0,
            available: true
        }
        const newRoomId = Math.random().toString(36).substr(2, 9)
        rooms[newRoomId] = newRoom
        this.setState({
            selectedRoomId: newRoomId,
            roomState: CREATE_STATE,
            rooms: rooms,
            errorMessages: {
                invalidName: false,
                invalidCapacity: false
            }
        })
    }

    handleRoomNameChange(event){
        const {rooms, selectedRoomId, errorMessages} = this.state
        const newName = event.target.value
        rooms[selectedRoomId].name = newName
        if (!validateField(STRING_FIELD, newName)){
            errorMessages.invalidName = true
        } else {
            errorMessages.invalidName = false
        }

        this.setState({
            rooms: rooms,
            errorMessages: errorMessages
        })
    }

    handleRoomCapacityChange(event){
        const {rooms, selectedRoomId, errorMessages} = this.state
        const newCapacity = event.target.value
        if (!validateField(NUMBER_FIELD, newCapacity)){
            errorMessages.invalidCapacity = true
        } else {
            errorMessages.invalidCapacity = false
        }
        rooms[selectedRoomId].capacity = newCapacity
        this.setState({
            rooms: rooms,
            errorMessages: errorMessages
        })
    }

    handleClickUpdate(event){
        const {rooms, selectedRoomId, roomState, errorMessages} = this.state
        // Perform one last sanity check
        const isCreate = roomState === CREATE_STATE || roomState === CREATE_FAILED_STATE
        if (!validateField(STRING_FIELD, rooms[selectedRoomId].name)){
            errorMessages.invalidName = true
            this.setState({
                errorMessages: errorMessages,
                roomState: isCreate ? CREATE_FAILED_STATE : UPDATE_FAILED_STATE
            })
            return
        }
        if (!validateField(NUMBER_FIELD, rooms[selectedRoomId].capacity)){
            errorMessages.invalidCapacity = true
            this.setState({
                errorMessages: errorMessages,
                roomState: isCreate ? CREATE_FAILED_STATE : UPDATE_FAILED_STATE
            })
            return
        }

        // Update room
        rooms[selectedRoomId].capacity = Number(rooms[selectedRoomId].capacity)
        const roomURL = `/rooms/${selectedRoomId}`
        Firebase.database().ref(roomURL).set(rooms[selectedRoomId])

        // Update events
        const eventsRef = Firebase.database().ref('/events')
        const sixHoursMiliseconds = 6*60*60*1000
        eventsRef.orderByChild('start').startAt(
            new Date().getTime() - sixHoursMiliseconds
        ).once('value', snapshot => {
            var eventsRaw = snapshot.val();
            const futureEvents = parseEvents(eventsRaw, false)
            for (var eventId in futureEvents){
                if (futureEvents[eventId].room.id === selectedRoomId){
                    // Need to update this register
                    Firebase.database().ref(`/events/${eventId}/room`).set(
                        {...rooms[selectedRoomId], id: selectedRoomId}
                    )
                }
            }
        })
        this.setState({
            roomState: isCreate ? CREATE_SUCCESS_STATE : UPDATE_SUCCESS_STATE
        })
    }

    getRoomErrors(){
        const {errorMessages} = this.state
        if (errorMessages.invalidName){
            return "El nombre de la sala no es valido"
        }
        if (errorMessages.invalidCapacity){
            return "Numero invalido en capacidad de sala"
        }
        return ""
    }

    handleClickDelete(){
        const {selectedRoomId, rooms} = this.state
        const roomURL = `/rooms/${selectedRoomId}`
        Firebase.database().ref(roomURL).remove()
        delete rooms[selectedRoomId]
        this.setState({
            rooms: rooms,
            selectedRoomId: null,
            roomState: DELETED_STATE
        })
    }

    handleRoomAvailableChange(){
        const {rooms, selectedRoomId} = this.state
        rooms[selectedRoomId].available = !rooms[selectedRoomId].available
        this.setState({
            rooms: rooms
        })

    }

    componentDidMount(){
        // Get all rooms
        let ref = Firebase.database().ref('/rooms')

        ref.once('value', snapshot => {
            var roomsRaw = snapshot.val();
            if (roomsRaw === null){
                roomsRaw = {}
            }
            this.setState({
                rooms: roomsRaw
            })
        })
    }

    render() {
        const {
            rooms,
            selectedRoomId,
            roomState,
            errorMessages
        } = this.state
        const {
            handleRoomChange,
            handleRoomCreate,
            handleRoomNameChange,
            handleRoomCapacityChange,
            handleRoomAvailableChange,
            handleClickUpdate,
            handleClickDelete,
            getRoomErrors
        } = this
        return (
            <div className="registerForm">
                <div className="shadow-box date-selection-block">
                    <div className="guests-block">
                        <div className="personal-data-block">
                            <CustomRoomPicker
                                rooms={[CREATE_STATE, CREATE_FAILED_STATE].includes(roomState) ? {} : rooms}
                                selectedRoomId={selectedRoomId}
                                onRoomSelected={handleRoomChange}
                                disabled={[CREATE_STATE, CREATE_FAILED_STATE].includes(roomState)}
                            />
                        </div>
                        <div>
                            <ThemeProvider theme={appTheme}>
                                <Button color="primary" variant="contained" onClick={handleRoomCreate} disabled={false}>
                                    <FaPlus/>Añadir sala
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>
                </div>
                <div>
                {
                    selectedRoomId ?
                        <div className="guests-block">
                            <div>
                                <RoomDisplay
                                    room={rooms[selectedRoomId]}
                                    errorMessages={errorMessages}
                                    disabled={
                                        [CREATE_SUCCESS_STATE, UPDATE_SUCCESS_STATE, DELETED_STATE].includes(roomState)
                                    }
                                    onNameChange={handleRoomNameChange}
                                    onCapacityChange={handleRoomCapacityChange}
                                    onAvailableChange={handleRoomAvailableChange}
                                />
                            </div>
                            <div className="guests-block">
                                <div className="inline-element horizontal-block">
                                    <input
                                        className="button-add-reserve"
                                        type="button"
                                        value={
                                            [CREATE_STATE, CREATE_FAILED_STATE, CREATE_SUCCESS_STATE].includes(roomState) ?
                                            "Crear": "Actualizar"
                                        }
                                        disabled={[CREATE_SUCCESS_STATE, UPDATE_SUCCESS_STATE].includes(roomState)}
                                        onClick={handleClickUpdate}/>
                                </div>
                                {
                                    [FOUND_STATE, UPDATE_FAILED_STATE, UPDATE_SUCCESS_STATE].includes(roomState) ?
                                    <div className="inline-element horizontal-block">
                                        <input
                                            className="button-warning"
                                            type="button"
                                            value="Eliminar Sala"
                                            disabled={[UPDATE_SUCCESS_STATE].includes(roomState)}
                                            onClick={handleClickDelete}
                                        />
                                    </div> : <div></div>
                                }
                            </div>
                            <div>
                                {
                                    [UPDATE_FAILED_STATE, CREATE_FAILED_STATE].includes(roomState) ?
                                        <div className="error-message">{getRoomErrors()}</div> :
                                        roomState === UPDATE_SUCCESS_STATE ?
                                            <div className="text-success">
                                                Actualizado correctamente<FaCheckCircle className="icon-check-circle"/>
                                            </div> :
                                        roomState === DELETED_STATE ?
                                            <div className="text-error">
                                                Eliminado correctamente <FaCheckCircle className="icon-check-circle"/>
                                            </div> :
                                        roomState === CREATE_SUCCESS_STATE ?
                                            <div className="text-success">
                                                Creado correctamente<FaCheckCircle className="icon-check-circle"/>
                                            </div> :
                                        <div> &nbsp;</div>
                                }
                            </div>
                        </div>:<div> </div>
                }
                </div>
            </div>
        )
    }
}

export default RoomsAdmin
